/**
 * Right-panel operation buttons (restaurant ERP POS pattern).
 * @typedef {'default' | 'amber' | 'red' | 'primary'} PosOperationTone
 * @typedef {object} PosOperationDef
 * @property {string} id
 * @property {string} label
 * @property {string} [shortcut]
 * @property {boolean} [requiresLine]
 * @property {PosOperationTone} [tone]
 * @property {boolean} [fullWidth]
 */

/** @type {PosOperationDef[]} */
export const POS_LINE_OPERATIONS = [
  { id: 'stylist', label: 'Stylist', requiresLine: true, tone: 'primary' },
  { id: 'lineStatus', label: 'Status', requiresLine: true, tone: 'default' },
  { id: 'split', label: 'Split %', requiresLine: true, tone: 'default' },
  { id: 'qtyPlus', label: 'Qty +', requiresLine: true, tone: 'default' },
  { id: 'qtyMinus', label: 'Qty −', requiresLine: true, tone: 'default' },
  { id: 'lineDiscount', label: 'Line Disc', shortcut: 'F8', requiresLine: true, tone: 'amber' },
  { id: 'price', label: 'Price', requiresLine: true, tone: 'default' },
  { id: 'duplicate', label: 'Duplicate', requiresLine: true, tone: 'default' },
  { id: 'addon', label: 'Add-on', requiresLine: true, tone: 'default' },
  { id: 'delete', label: 'Delete', requiresLine: true, tone: 'red' },
]

/** @type {PosOperationDef[]} */
export const POS_TICKET_OPERATIONS = [
  { id: 'floorQueue', label: 'Floor', tone: 'primary' },
  { id: 'package', label: 'Package', shortcut: 'F6', tone: 'default' },
  { id: 'redeem', label: 'Redeem', shortcut: 'F7', tone: 'default' },
  { id: 'hold', label: 'Hold', shortcut: 'F5', tone: 'amber' },
  { id: 'recall', label: 'Load ticket', shortcut: 'F10', tone: 'default' },
  { id: 'voucher', label: 'Voucher', shortcut: 'F9', tone: 'amber' },
  { id: 'ticketNote', label: 'Note', tone: 'default' },
  { id: 'billDiscount', label: 'Bill Disc', tone: 'amber' },
]
